export enum OrganisingInstitutionTypeEnum {
    Other = "718230005"
}